var _defs, _g, _g2, _path, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSftpUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "scale(1)",
    id: "_0160_data_arranging",
    "data-name": "0160_data_arranging",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    className: "show_show__wrapper__graphic__5Waiy ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#231f20;}.cls-3{fill:#d1d3d4;}.cls-4{fill:#135FC2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left_hand",
    "data-name": "left hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.61,192.6c-3.33,1.28-5.07-.6-6.49-5.23a6.73,6.73,0,0,1-.21-2.53,23.35,23.35,0,0,1,.67-3.7,62.39,62.39,0,0,1,3.52-9.93c.35-.81,1-1.77,1.87-1.49s.82,1.17.81,1.92c-.05,2.1-.36,4.21-.3,6.3,4.42-1.12,7.2-5.8,11.41-6.8,1.19-.28,2.63-.38,2.76,1.16.15,1.89-3.27,3.38-4.41,4.37a13.77,13.77,0,0,1,4.33-2.53,2.84,2.84,0,0,1,1.43-.22,1.1,1.1,0,0,1,.95,1,1.58,1.58,0,0,1-.5,1,14.81,14.81,0,0,1-2.18,2,5.48,5.48,0,0,1,3.07-1.81,1.57,1.57,0,0,1,1.68.46c.49.8-.45,1.7-1.27,2.16a5,5,0,0,1,2.29-1.14A1.69,1.69,0,0,1,161,178.9a2.34,2.34,0,0,1-.9,1.71C155.7,184.9,145.21,190.44,139.61,192.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.74,193.69a3.75,3.75,0,0,1-1.67-.37c-1.51-.74-2.63-2.51-3.62-5.74a7.65,7.65,0,0,1-.24-2.79,26.25,26.25,0,0,1,.68-3.8,63.2,63.2,0,0,1,3.57-10.05c.64-1.52,1.69-2.24,2.74-1.88.6.2,1.31.82,1.28,2.59,0,.9-.09,1.8-.15,2.71s-.13,1.75-.15,2.62a18.14,18.14,0,0,0,4.67-3c1.78-1.45,3.63-2.94,5.88-3.47a3.5,3.5,0,0,1,2.82.22,2.05,2.05,0,0,1,.79,1.56,2.4,2.4,0,0,1-.13,1,2.52,2.52,0,0,1,.91,0,1.8,1.8,0,0,1,1.53,1.6,1.54,1.54,0,0,1-.07.54,2,2,0,0,1,2,.83,1.65,1.65,0,0,1,.23.71H159a2.69,2.69,0,0,1,2,.57,2,2,0,0,1,.74,1.37,3,3,0,0,1-1.11,2.27c-4.47,4.41-15.07,10-20.69,12.14h0A5.79,5.79,0,0,1,137.74,193.69Zm1.87-1.09h0Zm-.93-22.23c-.26,0-.66.47-.93,1.12a61,61,0,0,0-3.49,9.81,22.38,22.38,0,0,0-.65,3.59,6.21,6.21,0,0,0,.18,2.28c.86,2.79,1.77,4.34,2.89,4.89a3.29,3.29,0,0,0,2.68-.12h0c5.62-2.17,16-7.72,20.21-11.83.31-.31.73-.76.69-1.16a.6.6,0,0,0-.23-.4,1.35,1.35,0,0,0-.92-.26,2.87,2.87,0,0,0-1.24.51,4.86,4.86,0,0,1-.77.54.7.7,0,0,1-.77-1.17l.69-.49a1.33,1.33,0,0,0,.42-.58.19.19,0,0,0,0-.17c-.1-.17-.49-.22-.94-.13a4.81,4.81,0,0,0-1.44.54,14.54,14.54,0,0,1-1.35,1.14.7.7,0,0,1-.95-1,5.88,5.88,0,0,1,1.44-1.24c.26-.25.5-.51.74-.78.09-.11.34-.39.33-.56s-.18-.25-.38-.28a2.34,2.34,0,0,0-1.06.19,14,14,0,0,0-1.64.71c-.42.31-.87.6-1.29.87a11.66,11.66,0,0,0-1.19.82.7.7,0,0,1-.91-1.06,14.29,14.29,0,0,1,2.63-1.81c.85-.62,1.59-1.33,1.54-2,0-.39-.18-.5-.23-.53s-.57-.26-1.67,0c-1.94.46-3.58,1.79-5.32,3.2a16.37,16.37,0,0,1-6.08,3.6.66.66,0,0,1-.59-.12.69.69,0,0,1-.28-.54c0-1.24.06-2.5.15-3.71.07-.87.13-1.75.15-2.63,0-.69-.11-1.16-.33-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.69,178.14a7,7,0,0,1,.13,8.7l.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.82,187.54a.69.69,0,0,1-.54-1.14,6.27,6.27,0,0,0-.12-7.8.7.7,0,0,1,1.06-.92,7.77,7.77,0,0,1,.67,8.85.51.51,0,0,1,.06.25.69.69,0,0,1-.66.73l-.43,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.61,
    y: 154.79,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246,187.9H147.47a8.59,8.59,0,0,1-8.58-8.59V162.65a8.59,8.59,0,0,1,8.58-8.58H246a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,246,187.9Zm-98.56-32.39a7.16,7.16,0,0,0-7.14,7.14v16.66a7.15,7.15,0,0,0,7.14,7.14H246a7.14,7.14,0,0,0,7.14-7.14V162.65a7.15,7.15,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.13,174.48a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,153.13,174.48Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,153.13,168.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M165,174.48a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,165,174.48Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,165,168.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M243.17,173.33H175.26a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.71.7v3.3A.7.7,0,0,1,243.17,173.33ZM176,171.93h66.52V170H176Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    id: "floor",
    d: "M455.36,351.1H44.64a.7.7,0,0,1,0-1.4H455.36a.7.7,0,1,1,0,1.4Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Server_Rack_1",
    "data-name": "Server Rack #1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.37,
    y: 126.99,
    width: 98.63,
    height: 218
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,345.71H309.37a.72.72,0,0,1-.72-.72V127a.72.72,0,0,1,.72-.72H408a.73.73,0,0,1,.73.72V345A.73.73,0,0,1,408,345.71Zm-97.9-1.44h97.18V127.71H310.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 122.32,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,155.42H309.41a8.59,8.59,0,0,1-8.58-8.58V130.18a8.59,8.59,0,0,1,8.58-8.58H408a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,408,155.42ZM309.41,123a7.14,7.14,0,0,0-7.14,7.14v16.66a7.14,7.14,0,0,0,7.14,7.14H408a7.14,7.14,0,0,0,7.14-7.14V130.18A7.14,7.14,0,0,0,408,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,142a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,315.07,142Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,315.07,136.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.89,142a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,326.89,142Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,326.89,136.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.11,140.86H337.2a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,405.11,140.86Zm-67.21-1.4h66.51v-1.9H337.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 162.22,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,195.32H309.41a8.59,8.59,0,0,1-8.58-8.58V170.08a8.59,8.59,0,0,1,8.58-8.58H408a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,408,195.32Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.14,7.14,0,0,0,7.14,7.14H408a7.14,7.14,0,0,0,7.14-7.14V170.08a7.14,7.14,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,181.91a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,315.07,181.91Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,315.07,176.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.89,181.91a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,326.89,181.91Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,326.89,176.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.11,180.76H337.2a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,405.11,180.76Zm-67.21-1.4h66.51v-1.9H337.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 202.12,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,235.22H309.41a8.59,8.59,0,0,1-8.58-8.58V210a8.59,8.59,0,0,1,8.58-8.58H408a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,408,235.22Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.14,7.14,0,0,0,7.14,7.14H408a7.14,7.14,0,0,0,7.14-7.14V210a7.14,7.14,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,221.81a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,315.07,221.81Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,315.07,216.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.89,221.81a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,326.89,221.81Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,326.89,216.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.11,220.66H337.2a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7V220A.7.7,0,0,1,405.11,220.66Zm-67.21-1.4h66.51v-1.9H337.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 242.02,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,275.12H309.41a8.59,8.59,0,0,1-8.58-8.58V249.88a8.59,8.59,0,0,1,8.58-8.58H408a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,408,275.12Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.15,7.15,0,0,0,7.14,7.14H408a7.15,7.15,0,0,0,7.14-7.14V249.88a7.14,7.14,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,261.71a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,315.07,261.71Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,315.07,256.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.89,261.71a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,326.89,261.71Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,326.89,256.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.11,260.56H337.2a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,405.11,260.56Zm-67.21-1.4h66.51v-1.9H337.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 281.92,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,315H309.41a8.59,8.59,0,0,1-8.58-8.58V289.78a8.58,8.58,0,0,1,8.58-8.58H408a8.58,8.58,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,408,315Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.14,7.14,0,0,0,7.14,7.14H408a7.14,7.14,0,0,0,7.14-7.14V289.78a7.14,7.14,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,301.61a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,315.07,301.61Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,315.07,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.89,301.61a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,326.89,301.61Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,326.89,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.11,300.46H337.2a.71.71,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,405.11,300.46Zm-67.21-1.4h66.51v-1.9H337.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 301.55,
    y: 321.82,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M408,354.92H309.41a8.59,8.59,0,0,1-8.58-8.58V329.68a8.58,8.58,0,0,1,8.58-8.58H408a8.58,8.58,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,408,354.92Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.15,7.15,0,0,0,7.14,7.14H408a7.15,7.15,0,0,0,7.14-7.14V329.68a7.14,7.14,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.07,341.51a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,315.07,341.51Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,315.07,335.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.89,341.51a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,326.89,341.51Zm0-5.6A2.1,2.1,0,1,0,329,338,2.1,2.1,0,0,0,326.89,335.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.11,340.36H337.2a.71.71,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,405.11,340.36ZM337.9,339h66.51v-1.9H337.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 312.86,
    y: 354.2,
    width: 11.83,
    height: 4.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324.69,359.74H312.86a.72.72,0,0,1-.72-.72V354.2a.72.72,0,0,1,.72-.72h11.83a.72.72,0,0,1,.72.72V359A.72.72,0,0,1,324.69,359.74Zm-11.11-1.44H324v-3.38H313.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 392.69,
    y: 354.2,
    width: 11.83,
    height: 4.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.52,359.74H392.69A.72.72,0,0,1,392,359V354.2a.72.72,0,0,1,.72-.72h11.83a.72.72,0,0,1,.72.72V359A.72.72,0,0,1,404.52,359.74Zm-11.11-1.44h10.38v-3.38H393.41Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Server_Rack_2",
    "data-name": "Server Rack #2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 177.55,
    y: 209.8,
    width: 98.63,
    height: 135.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.18,345.71H177.55a.72.72,0,0,1-.72-.72V209.8a.73.73,0,0,1,.72-.73h98.63a.73.73,0,0,1,.73.73V345A.73.73,0,0,1,276.18,345.71Zm-97.9-1.44h97.18V210.52H178.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.73,
    y: 202.12,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.15,235.22H177.59a8.59,8.59,0,0,1-8.58-8.58V210a8.59,8.59,0,0,1,8.58-8.58h98.56a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,276.15,235.22Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.14,7.14,0,0,0,7.14,7.14h98.56a7.15,7.15,0,0,0,7.14-7.14V210a7.15,7.15,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.25,221.81a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,183.25,221.81Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,183.25,216.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.07,221.81a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,195.07,221.81Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,195.07,216.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.29,220.66H205.38a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7V220A.7.7,0,0,1,273.29,220.66Zm-67.21-1.4h66.51v-1.9H206.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.73,
    y: 242.02,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.15,275.12H177.59a8.59,8.59,0,0,1-8.58-8.58V249.88a8.59,8.59,0,0,1,8.58-8.58h98.56a8.59,8.59,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,276.15,275.12Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.15,7.15,0,0,0,7.14,7.14h98.56a7.16,7.16,0,0,0,7.14-7.14V249.88a7.15,7.15,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.25,261.71a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,183.25,261.71Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,183.25,256.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.07,261.71a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,195.07,261.71Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,195.07,256.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.29,260.56H205.38a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,273.29,260.56Zm-67.21-1.4h66.51v-1.9H206.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.73,
    y: 281.92,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.15,315H177.59a8.59,8.59,0,0,1-8.58-8.58V289.78a8.58,8.58,0,0,1,8.58-8.58h98.56a8.58,8.58,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,276.15,315Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.14,7.14,0,0,0,7.14,7.14h98.56a7.15,7.15,0,0,0,7.14-7.14V289.78a7.15,7.15,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.25,301.61a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,183.25,301.61Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,183.25,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.07,301.61a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,195.07,301.61Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,195.07,296Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.29,300.46H205.38a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,273.29,300.46Zm-67.21-1.4h66.51v-1.9H206.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.73,
    y: 321.82,
    width: 114.28,
    height: 32.38,
    rx: 7.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.15,354.92H177.59a8.59,8.59,0,0,1-8.58-8.58V329.68a8.58,8.58,0,0,1,8.58-8.58h98.56a8.58,8.58,0,0,1,8.58,8.58v16.66A8.59,8.59,0,0,1,276.15,354.92Zm-98.56-32.38a7.14,7.14,0,0,0-7.14,7.14v16.66a7.15,7.15,0,0,0,7.14,7.14h98.56a7.16,7.16,0,0,0,7.14-7.14V329.68a7.15,7.15,0,0,0-7.14-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.25,341.51a3.5,3.5,0,1,1,3.5-3.5A3.51,3.51,0,0,1,183.25,341.51Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.11,2.11,0,0,0,183.25,335.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.07,341.51a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,195.07,341.51Zm0-5.6a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,195.07,335.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.29,340.36H205.38a.7.7,0,0,1-.7-.7v-3.3a.7.7,0,0,1,.7-.7h67.91a.7.7,0,0,1,.7.7v3.3A.7.7,0,0,1,273.29,340.36ZM206.08,339h66.51v-1.9H206.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 181.04,
    y: 354.2,
    width: 11.83,
    height: 4.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.87,359.74H181a.72.72,0,0,1-.72-.72V354.2a.72.72,0,0,1,.72-.72h11.83a.72.72,0,0,1,.72.72V359A.72.72,0,0,1,192.87,359.74Zm-11.11-1.44h10.39v-3.38H181.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 260.87,
    y: 354.2,
    width: 11.83,
    height: 4.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.7,359.74H260.87a.72.72,0,0,1-.72-.72V354.2a.72.72,0,0,1,.72-.72H272.7a.72.72,0,0,1,.72.72V359A.72.72,0,0,1,272.7,359.74Zm-11.11-1.44H272v-3.38H261.59Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Electricity"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M447.32,322.07H429.44a.7.7,0,0,1-.7-.7V307.18a.71.71,0,0,1,.7-.7h17.88a.71.71,0,0,1,.7.7v14.19A.7.7,0,0,1,447.32,322.07Zm-17.18-1.4h16.48V307.88H430.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M438.38,318.74a4.46,4.46,0,1,1,4.46-4.46A4.46,4.46,0,0,1,438.38,318.74Zm0-7.52a3.06,3.06,0,1,0,3.06,3.06A3.06,3.06,0,0,0,438.38,311.22Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.93,132.32a5.73,5.73,0,0,0-2.72-2.23,2.32,2.32,0,0,0-2.91,1.32c-2.79-4.37-8.87-5.35-14-4.41-8.54,1.58-14.51,4.88-17,13.7-.92,3.31-1.09,6.82-2.27,10.05s-3.2,5.92-5.07,8.72a1.76,1.76,0,0,0-.4,1.05,1.69,1.69,0,0,0,.61,1,11.59,11.59,0,0,0,4.36,3,4.93,4.93,0,0,0,5-.9,3.07,3.07,0,0,0,.07,3.8,6.91,6.91,0,0,0,3.44,2.16c8.56,2.86,19.16-.11,25.86-5.85a28.66,28.66,0,0,0,9-14.37C122.64,142.91,121,137.64,116.93,132.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.18,171.33a23.08,23.08,0,0,1-7.29-1.13,7.63,7.63,0,0,1-3.78-2.4,4.22,4.22,0,0,1-.84-2.61,6.21,6.21,0,0,1-3.88,0A12.42,12.42,0,0,1,72.76,162a1.94,1.94,0,0,1-.3-2.9l.89-1.32a34.2,34.2,0,0,0,4.1-7.25,34.14,34.14,0,0,0,1.34-5.65c.25-1.43.52-2.92.91-4.36,2.82-10.18,10.43-12.89,17.5-14.2,4.51-.83,10.71-.27,14,3.84a3,3,0,0,1,.6-.45,3.36,3.36,0,0,1,2.56-.28,6.52,6.52,0,0,1,3.08,2.47c4.52,5.89,5.8,11.32,4.13,17.61a29.43,29.43,0,0,1-9.19,14.72A30.38,30.38,0,0,1,93.18,171.33ZM82.6,162.88a.71.71,0,0,1,.49.2.7.7,0,0,1,0,1,2.38,2.38,0,0,0,.11,2.9,6.34,6.34,0,0,0,3.1,1.91c7.84,2.62,18.2.27,25.19-5.71a28,28,0,0,0,8.74-14c1.55-5.82.35-10.88-3.88-16.39h0a5.27,5.27,0,0,0-2.37-2,2,2,0,0,0-1.47.16,1.13,1.13,0,0,0-.56.67.71.71,0,0,1-1.27.2c-2.76-4.33-8.86-4.91-13.26-4.1-9.54,1.77-14.29,5.59-16.4,13.19-.38,1.38-.63,2.83-.88,4.23a34.88,34.88,0,0,1-1.4,5.88,35,35,0,0,1-4.27,7.57l-.88,1.3a1.43,1.43,0,0,0-.28.59,1.34,1.34,0,0,0,.4.54,11.17,11.17,0,0,0,4.09,2.83,4.31,4.31,0,0,0,4.28-.73A.7.7,0,0,1,82.6,162.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.56,148.81s5.07,7.27,4.09,8.83-4.35.62-4.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.35,159.24a9.52,9.52,0,0,1-2.24-.3.71.71,0,0,1-.49-.86.7.7,0,0,1,.86-.49c.94.26,3,.52,3.58-.32.33-.7-1.57-4.47-4.07-8.06a.69.69,0,0,1,.17-1,.7.7,0,0,1,1,.17c1.6,2.3,5.21,7.84,4.11,9.6A3.24,3.24,0,0,1,118.35,159.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.28,139.07c3.17,2.46,2.4,7.85,2.46,11.34q.12,7.36-.09,14.73c-.1,3.11-8.15,3.38-9.59,2.48l1.56,12.26s-3.84,1.15-10.42-1.7-6.67-4.38-6.67-4.38l.19-14.2s5.33-.09,8.32-6.51,2.62-16.15,2.62-16.15S112.18,136.67,115.28,139.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.41,180.81a21.5,21.5,0,0,1-8.48-2c-6.29-2.73-7.06-4.4-7.09-5L92,159.59a.7.7,0,0,1,.69-.69c.2,0,4.94-.19,7.7-6.1,2.88-6.19,2.56-15.74,2.55-15.84a.69.69,0,0,1,.19-.5.73.73,0,0,1,.49-.23c.36,0,8.81-.24,12.07,2.29h0c2.91,2.26,2.82,6.55,2.75,10,0,.66,0,1.3,0,1.88.08,4.91,0,9.87-.09,14.76a2.92,2.92,0,0,1-1.8,2.47,13.86,13.86,0,0,1-7.66,1l1.42,11.19a.69.69,0,0,1-.49.76A9.26,9.26,0,0,1,107.41,180.81Zm-14.17-7.12c.13.25,1.06,1.6,6.24,3.85,4.8,2.09,8.1,2,9.36,1.78l-1.48-11.61a.71.71,0,0,1,.32-.68.68.68,0,0,1,.74,0c.78.48,5.19.6,7.47-.63.68-.37,1-.8,1.06-1.28.14-4.87.17-9.81.09-14.7,0-.6,0-1.25,0-1.93.06-3.13.15-7-2.21-8.87-2.17-1.68-7.76-2-10.47-2,0,2.4-.12,10.21-2.71,15.77S95,160,93.42,160.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.88,162.93a4.13,4.13,0,0,1-1-.12,4.55,4.55,0,0,1-2.89-2.44.69.69,0,0,1,.27-1,.7.7,0,0,1,1,.27,3.26,3.26,0,0,0,2,1.76,4.26,4.26,0,0,0,2.87-.55.7.7,0,1,1,.76,1.17A6,6,0,0,1,114.88,162.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.23,152.19a6.73,6.73,0,0,0-1.46-3.34,9.86,9.86,0,0,0-1.83-2.18,3.24,3.24,0,0,0-2.67-.74,3,3,0,0,0-1.89,1.57,5.7,5.7,0,0,0-.55,2.45,10.53,10.53,0,0,0,5.09,9.22l-.28-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.92,159.87a.68.68,0,0,1-.36-.1,11.32,11.32,0,0,1-5.43-9.85,6.24,6.24,0,0,1,.63-2.75,3.67,3.67,0,0,1,2.35-1.92,3.85,3.85,0,0,1,3.26.87,10.23,10.23,0,0,1,2,2.34,7.33,7.33,0,0,1,1.58,3.7.71.71,0,0,1-.68.73.74.74,0,0,1-.72-.67,6.23,6.23,0,0,0-1.34-3,8.58,8.58,0,0,0-1.69-2,2.53,2.53,0,0,0-2.07-.61,2.3,2.3,0,0,0-1.43,1.21,5,5,0,0,0-.47,2.15,9.87,9.87,0,0,0,4.15,8.21.7.7,0,0,1,.46.21l.28.29a.7.7,0,0,1,0,.92A.72.72,0,0,1,103.92,159.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.06,167.62s-4.21-1.19-6.23-4c0,0,.46,7.47,6.92,9.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.75,173.78a.76.76,0,0,1-.21,0c-6.84-2.13-7.38-9.77-7.4-10.1a.69.69,0,0,1,.46-.7.7.7,0,0,1,.8.25c1.86,2.59,5.81,3.74,5.85,3.75a.71.71,0,0,1,.5.58l.69,5.46a.72.72,0,0,1-.24.63A.69.69,0,0,1,108.75,173.78Zm-5.81-8a9.46,9.46,0,0,0,5,6.25l-.49-3.86A15.25,15.25,0,0,1,102.94,165.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 113.68,
    cy: 145.48,
    rx: 1.75,
    ry: 0.69,
    transform: "translate(-46.54 237.24) rotate(-81.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.63,366.54l-1.36,9.92s30.61-1.6,29.55-4S89.14,367,89.14,367"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.27,377.16a.68.68,0,0,1-.51-.23.69.69,0,0,1-.18-.57l1.36-9.91a.7.7,0,0,1,1.39.19l-1.25,9.08c12.61-.69,26-2,28-3.21-1.1-1.54-6.08-3.76-9.14-4.87a.7.7,0,0,1-.42-.89.69.69,0,0,1,.89-.42c.92.33,8.95,3.28,10.09,5.86a1,1,0,0,1-.06.94c-1.41,2.29-21.51,3.58-30.09,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.42,189.18s15.17,15.21,22.69,13.08c4.44-1.26,24.94-11.54,25.18-12,1-1.66,2.87-7,4.08-8.47a3.2,3.2,0,0,1,1.78-1.33c3.9-.69.13,6.32-.88,7.5,3.31-2.06,6.72-4.1,10.22-5.84a1.41,1.41,0,0,1,1.2-.19,1,1,0,0,1,.34,1.23,2.78,2.78,0,0,1-.93,1l-6,4.73a44.12,44.12,0,0,1,5.46-3.86c.7-.41,2.64-1.64,3.36-.84,1.24,1.38-5.13,6.2-6.22,7a27.24,27.24,0,0,1,5.81-4.07,2.73,2.73,0,0,1,2-.43c.28.43-.17,1-.58,1.29l-4.16,3.21c2.08-1.53,4.37-3.14,7-3.1,0,.43-.35.78-.69,1-6.13,4.81-12.35,11-18.71,15.49-8.44,6-17.61,14.26-28.09,15.16-12.45,1.08-21.57-8-30-15.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.23,220.64c-11.25,0-19.86-8.08-27.51-15.26l-1-.94a.7.7,0,0,1,0-1,.71.71,0,0,1,1,0l1,.94c8.28,7.77,16.84,15.8,28.48,14.79,8.44-.73,16-6.31,23.21-11.71,1.54-1.15,3-2.27,4.54-3.33,3.66-2.59,7.34-5.8,10.9-8.9,2.38-2.08,4.84-4.22,7.25-6.14a15.56,15.56,0,0,0-4.89,2.75.69.69,0,0,1-1-.14.68.68,0,0,1,.13-1l4.07-3.16c-.18.07-.36.17-.54.26a26.1,26.1,0,0,0-2.74,1.64c-1.19,1-2.37,1.92-3,2.37a.7.7,0,0,1-.89-1.08,27.78,27.78,0,0,1,3-2.4c2-1.76,3.21-3.18,3.14-3.65,0,0,0,0-.12,0a5.29,5.29,0,0,0-2.23,1,43.34,43.34,0,0,0-4,2.68l-1.51,1.18a.7.7,0,1,1-.88-1.08c.5-.42,1-.83,1.54-1.22l4.46-3.51a2.56,2.56,0,0,0,.72-.76.42.42,0,0,0,0-.34s-.14,0-.58.19c-3.63,1.82-7.17,4-10.16,5.81a.7.7,0,0,1-.9-1.05c.91-1.06,2.93-5.2,2.35-6.22-.12-.21-.51-.18-.82-.13a2.72,2.72,0,0,0-1.36,1.08,29.61,29.61,0,0,0-2.48,5c-.61,1.41-1.13,2.63-1.53,3.33-.56.95-22.09,11.28-25.6,12.28-7.82,2.2-22.74-12.62-23.37-13.25a.7.7,0,0,1,1-1c.15.15,15,14.9,22,12.89,4.16-1.18,23.14-10.64,24.83-11.75.36-.65.86-1.82,1.39-3.06a28.34,28.34,0,0,1,2.69-5.39,3.84,3.84,0,0,1,2.2-1.57,2,2,0,0,1,2.27.81c.71,1.24-.08,3.5-1,5.29,2.43-1.47,5.11-3,7.85-4.38a2.06,2.06,0,0,1,1.81-.19,1.64,1.64,0,0,1,.73,2,1.72,1.72,0,0,1,1.74.43,1.33,1.33,0,0,1,.33,1.08,3.06,3.06,0,0,1-.52,1.25,2.59,2.59,0,0,1,1.41,0,.7.7,0,0,1,.39.28,1.27,1.27,0,0,1,.09,1.24,7.24,7.24,0,0,1,1.56-.15.69.69,0,0,1,.68.64,2,2,0,0,1-1,1.66c-2.55,2-5.18,4.29-7.72,6.51-3.59,3.12-7.29,6.36-11,9-1.48,1-3,2.16-4.52,3.3-7.07,5.26-15.08,11.23-23.92,12C155.58,220.61,154.9,220.64,154.23,220.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.72 232.32 144.26 368.3 125.43 367.81 103.4 277.39 90.93 368.04 69.78 366.54 76.06 225.92 126.72 232.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.35,175.15l31.87,21.12-9.17,24.11s-39.19-26-39.47-31.94S118.35,175.15,118.35,175.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.19,256.53s-1-41.46-4-59.47c-1.26-7.65-.78-13-3.31-17.14-8.5-13.88-41.61-9.74-46.43-.11S71.54,259,71.54,259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.43,367.81s-.53,8.21.53,9.54,30-1.06,28.66-4.24-12-5.87-12-5.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.73,378.4c-2.34,0-4-.18-4.31-.62-1.15-1.42-.82-8-.69-10a.7.7,0,0,1,1.4.09c-.24,3.7-.17,8.08.33,9,2,.7,19.6-.5,25.89-2.71,1.44-.5,1.62-.85,1.62-.86-.86-2-7.49-4.34-11.47-5.35a.7.7,0,0,1,.35-1.35c1.12.28,11,2.88,12.42,6.28.17.41.27,1.21-1,2C151.28,376.57,137.05,378.4,129.73,378.4Zm-3.22-1.49h0Zm-.12-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141,221.08a.75.75,0,0,1-.37-.11c-.89-.57-21.89-13.92-29.16-20.93a.71.71,0,0,1,0-1,.7.7,0,0,1,1,0c7.17,6.92,28.72,20.62,28.94,20.76a.7.7,0,0,1,.22,1A.72.72,0,0,1,141,221.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSftpUser);
export default __webpack_public_path__ + "static/media/SftpUser.100a395cdcd8692be4538c2eceb40499.svg";
export { ForwardRef as ReactComponent };